import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import NumberFormat from "react-number-format";
import classNames from "classnames";
import { useCalculator } from "../../use-calculator";

export const InputField = () => {
  const { value, changeValue } = useCalculator();

  return (
    <>
      <label
        className={classNames(
          "input input-bordered flex h-[50px] w-full items-center gap-3 border border-solid border-divider bg-transparent px-5 duration-300",
          "rounded-sm text-regular text-primary-content placeholder:text-base-400",
          "focus-within:border-primary-content focus-within:shadow-md focus-within:outline-none",
        )}
      >
        <NumberFormat
          className="w-full"
          thousandSeparator="'"
          value={value}
          onValueChange={(v) => changeValue(v.floatValue)}
          placeholder="CHF 0"
          prefix="CHF "
          allowNegative={false}
        />
        {!!value && (
          <button onClick={() => changeValue(undefined)}>
            <StaticImage
              className="!align-middle"
              src="./clear_icon.png"
              alt="clear icon"
              width={16.3}
              height={16.3}
            />
          </button>
        )}
      </label>
    </>
  );
};
